import React, { useState } from "react";
import BlanqueadorContraseaUsuariosQR from "../Inscripciones/BlanqueadorContraseaUsuariosQR";


const Pantalla = () => {
  const [mostrarQR, setMostrarQR] = useState(false);

  return (
    <div>
      <button onClick={() => setMostrarQR(true)}>
        Abrir lector QR
      </button>

      {mostrarQR && (
        <BlanqueadorContraseaUsuariosQR
          onClose={() => setMostrarQR(false)}
        />
      )}
    </div>
  );
};

export default Pantalla;